"use client";
// 코스피/코스닥 실시간 지수 SSE(/api/market/stream) 구독 훅 — 폴링(/api/market) 값 위에 덮어쓴다

import { useEffect, useState } from "react";

export interface LiveIndex {
  price: number;
  change_rate: number;
}

/**
 * SSE /api/market/stream 구독. 서버가 변경분만 보내므로 받은 심볼만 갱신한다.
 * 연결이 끊기면 보관값을 비워 폴링 값으로 폴백한다 (끊긴 뒤 stale 시세를 계속
 * 덮어쓰는 것 방지). EventSource 는 브라우저가 자동 재연결한다.
 */
export function useMarketStream(): Record<string, LiveIndex> {
  const [live, setLive] = useState<Record<string, LiveIndex>>({});

  useEffect(() => {
    const es = new EventSource("/api/market/stream");
    es.onmessage = (e) => {
      try {
        const patch = JSON.parse(e.data) as Record<string, LiveIndex>;
        setLive((prev) => ({ ...prev, ...patch }));
      } catch {
        // ignore parse errors
      }
    };
    es.onerror = () => setLive({});
    return () => es.close();
  }, []);

  return live;
}
